import { useState, createContext, useContext } from "react";

const ThemeContext = createContext(
  { darkTheme: true, toggleTheme: () => { } }
);

export function useThemeContext() {
  return useContext(ThemeContext);
}

function ThemeProvider({ children }) {
  const [darkTheme, setDarkTheme] = useState(true);
  function toggleTheme() {
    setDarkTheme((prevDarkTheme) => !prevDarkTheme);
  }
  return (
    <>
      <ThemeContext.Provider value={{ darkTheme, toggleTheme }}>
        {children}
      </ThemeContext.Provider>
    </>
  );
}

export default ThemeProvider;
